if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.productsToshow = parseInt(this.dataset.productsToShow);
      this.init();
    }

    init() {
      fetch(this.dataset.url + this.getQueryString())
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('recently-viewed-products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.products = recommendations.querySelectorAll('.card-wrapper').length;

            if (this.products > 0) {
              this.classList.remove('hidden');
              this.innerHTML = recommendations.innerHTML;
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    getQueryString() {
      const cookieName = 'utenzo-recently-viewed';
      const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]');
      if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
        items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
      }
      return items
        .reverse()
        .map((item) => 'id:' + item)
        .slice(0, this.productsToshow)
        .join(' OR ');
    }
  }
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
